import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { useLegacyWalletStore } from '@app/store/zustand';

import { ConnectWalletSheet } from '../ConnectWalletSheet';

export function WalletOverlays() {
    const { getShowState } = useLegacyWalletStore();

    const walletSheet = getShowState() ? <ConnectWalletSheet key="ConnectWalletSheet" /> : null;

    return <AnimatePresence>{walletSheet}</AnimatePresence>;
}
